import { c as _c } from "react/compiler-runtime";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { useAppParams } from "@router/router-helper";
import { companyMemberGroupDetailSelector, companyMemberGroupDetailStatusSelector } from "@store/company-member-groups/company-member-groups-selector";
import { removeProjectsFromGroup } from "@store/company-member-groups/company-member-groups-slice";
import { fetchCompanyMemberGroupDetails } from "@store/company-member-groups/company-member-groups-thunk";
import { fetchProjectsByIds } from "@store/projects/projects-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { useCallback, useEffect } from "react";
/** Fetches the details of group of a company member */
export function useMemberGroupDetails(t0) {
  const $ = _c(21);
  const {
    groupId
  } = t0;
  const dispatch = useAppDispatch();
  const {
    memberId,
    teamId
  } = useAppParams();
  const {
    handleErrorWithToast
  } = useErrorContext();
  let t1;
  if ($[0] !== groupId) {
    t1 = companyMemberGroupDetailSelector(groupId);
    $[0] = groupId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const groupDetails = useAppSelector(t1);
  let t2;
  if ($[2] !== groupId) {
    t2 = companyMemberGroupDetailStatusSelector(groupId);
    $[2] = groupId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const groupDetailsStatus = useAppSelector(t2);
  let t3;
  if ($[4] !== dispatch || $[5] !== groupId || $[6] !== handleErrorWithToast || $[7] !== memberId || $[8] !== teamId) {
    t3 = async () => {
      const id = memberId || teamId;
      if (!id) {
        return;
      }
      ;
      try {
        const {
          projectIds
        } = await dispatch(fetchCompanyMemberGroupDetails({
          groupId,
          userIdentity: id
        })).unwrap();
        if (projectIds.length > 0) {
          dispatch(fetchProjectsByIds({
            projectIds
          }));
        }
      } catch (t4) {
        const error = t4;
        handleErrorWithToast({
          id: `getCompanyMemberGroupDetails-${groupId}`,
          title: "Cannot fetch workspace member group details",
          error
        });
      }
    };
    $[4] = dispatch;
    $[5] = groupId;
    $[6] = handleErrorWithToast;
    $[7] = memberId;
    $[8] = teamId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const fetchDetails = t3;
  let t4;
  let t5;
  if ($[10] !== fetchDetails) {
    t4 = () => {
      fetchDetails();
    };
    t5 = [fetchDetails];
    $[10] = fetchDetails;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] !== dispatch || $[14] !== groupId) {
    t6 = projectIds_0 => {
      dispatch(removeProjectsFromGroup({
        groupId,
        projectIds: projectIds_0
      }));
    };
    $[13] = dispatch;
    $[14] = groupId;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const removeProjects = t6;
  const t7 = groupDetailsStatus === "pending";
  let t8;
  if ($[16] !== fetchDetails || $[17] !== groupDetails || $[18] !== removeProjects || $[19] !== t7) {
    t8 = {
      groupDetails,
      isFetchingGroupDetails: t7,
      removeProjects,
      refetchDetails: fetchDetails
    };
    $[16] = fetchDetails;
    $[17] = groupDetails;
    $[18] = removeProjects;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}